import ExtendedOrderDetailContainer from '@/components/OrdersModule/OrderDetail/ExtendedOrderDetailContainer'
import Tabs from '@/features/archive/components/Tabs'
import { useScreenLayout } from '@/hooks/screen'
import { FC } from 'react'
import { View } from 'react-native'

const Layout: FC = () => {
    const screenLayout = useScreenLayout()

    if (screenLayout === 'compact') return <Tabs />

    return (
        <View style={{ flex: 1, flexDirection: 'row' }}>
            <Tabs />
            <View style={{ flex: 1 }}></View>
            <ExtendedOrderDetailContainer />
        </View>
    )
}

export default Layout
